export default __webpack_public_path__ + "static/media/Shadow's Arm-straps of Ushering Twilight.639da9e1.jpg";